export interface PendingPaymentStorage {
  orderId: string;
  userId: number | string;
  createdAt: number;
}

const PAYMENT_STORAGE_KEY = "lastPayment";
const MAX_PAYMENT_LIFETIME = 1000 * 60 * 30;

export const setPendingPaymentToStorage = (data: PendingPaymentStorage) => {
  localStorage.setItem(PAYMENT_STORAGE_KEY, JSON.stringify(data));
};

export const getPendingPaymentFromStorage =
  (): PendingPaymentStorage | null => {
    try {
      const raw = localStorage.getItem(PAYMENT_STORAGE_KEY);

      if (!raw) return null;

      const parsed = JSON.parse(raw) as PendingPaymentStorage;

      if (!parsed?.orderId || !parsed?.userId || !parsed?.createdAt) {
        localStorage.removeItem(PAYMENT_STORAGE_KEY);
        return null;
      }

      const isExpired = Date.now() - parsed.createdAt > MAX_PAYMENT_LIFETIME;

      if (isExpired) {
        localStorage.removeItem(PAYMENT_STORAGE_KEY);
        return null;
      }

      return parsed;
    } catch {
      localStorage.removeItem(PAYMENT_STORAGE_KEY);
      return null;
    }
  };

export const removePendingPaymentFromStorage = () => {
  localStorage.removeItem(PAYMENT_STORAGE_KEY);
};
